<template>
  <div>
    <div class="l-container">
      <router-view :advisor="advisor"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    advisor () {
      return this.$store.getters.advisor
    }
  },
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAdvisor(to.params.id)
    })
  },
  methods: {
    getAdvisor (id) {
      this.$store.dispatch('getAdvisor', id)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Advisor.vue?4920504c